export default class ServiceDeliveryLocation {
}
